<template lang="pug">
  .pdp-xsell-carousel
    .carousel-wrap
      slick(v-if="xsellRecommendations.length > 0" ref="slick" :options="carouselOptions").the-carousel
        .img.text-center.clickable(v-for="item in xsellRecommendations" :key="item.id")
          a.img-wrap.link-unstyled(:href="`/product/` + item.url_key")
            img(v-if="!!item.imagery.standard" :src="item.imagery.standard.url" :alt="item.imagery.standard.alt_text")
            p.prod-type.color-purple.upper.semi-bold.xs-f-xmedium.md-f-large.lg-f-xmedium.max-at-tweak {{ item.product_type_name }}
            p.prod-name.thin.xs-f-medium.md-f-xmedium.lg-f-medium.max-at-tweak {{ item.name }}
            p.prod-desc.normal.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{ item.short_description }}

      button.left-nav.btn-reset.text-right.clickable(type="button" @click="prev")
        span.color-gray.icon-caret-left.xs-f-grande.sm-f-xgrande.md-f-xxgrande.max-at-tweak
          span.ada-tooltip previous

      button.right-nav.btn-reset.text-left.clickable(type="button" @click="next")
        span.color-gray.icon-caret-right.xs-f-grande.sm-f-xgrande.md-f-xxgrande.max-at-tweak
          span.ada-tooltip next
  
</template>

<script>
  import { getXsellItemsForProduct } from "../../../services/vueXsellSvc";

  export default {
    name: "PdpXsellCarousel",
    props: {
      productCode: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        xsellRecommendations: [],
        carouselOptions: {
          autoplay: false,
          infinite: true,
          slidesToShow: 3,
          responsive: [{
            breakpoint: 960,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 560,
            settings: {
              slidesToShow: 1
            }
          }]
        }
      }
    },

    methods: {
      next() {
        this.$refs.slick.next();
      },

      prev() {
        this.$refs.slick.prev();
      },

      getRecommendations() {
        getXsellItemsForProduct({ productCode: this.productCode }).then(res => {
          this.xsellRecommendations = res.data;
        });
      }
    },

    mounted() {
      this.getRecommendations();
    }
  }
</script>

<style lang="stylus">
  .pdp-xsell-carousel
    .carousel-wrap
      position relative

      .the-carousel
        display none

        &.slick-initialized
          display block

        .img
          display block
          width 20em

          img
            margin auto
            max-width 100%

          .img-wrap
            display block
            padding 5%
            text-decoration none

            p
              text-decoration none

            .prod-type
              padding-top 1em

            .prod-desc
              padding 0 10%
              padding-top 0.2em

      .left-nav
      .right-nav
        position absolute
        height 100%
        top 0
        background color-white

        span
          position absolute
          top 36%
          margin-top -0.75em

          &:before
            margin 0

        .icon-caret-left
          left 1%

        .icon-caret-right
          right 1%

      .left-nav
        left 0

      .right-nav
        right 0

    @media mq-mobile
      .carousel-wrap
        padding 0 10%

        .left-nav
        .right-nav
          width 12%

    @media mq-tablet
      .carousel-wrap
        padding 0 10%

        .left-nav
        .right-nav
          width 10%

    @media mq-desktop-md
      .carousel-wrap
        padding 0 11%

        .left-nav
        .right-nav
          width 11%

    @media mq-desktop-plus
      .carousel-wrap
        padding 0 6%

        .left-nav
        .right-nav
          width 6%

</style>